<div class="mobile-navigation">
  <button #toggleButtonRef mat-icon-button class="mobile-nav-toggle-button" (click)="onToggle()" aria-controls="mobile-nav-container" [attr.aria-expanded]="isVisible">
    <mat-icon class="button-icon material-icons-outlined">
      {{ isVisible ? 'close' : 'menu' }}
    </mat-icon>
    <span class="button-text sr-only" i18n>
      {{ isVisible ? 'Close menu' : 'Show menu' }}
    </span>
  </button>

  <div id="mobile-nav-container" class="mobile-nav-container" [ngClass]="{ hidden: !isVisible }">
    <div #mobileNavRef class="main-nav-mobile">
      <ng-content></ng-content>
    </div>
  </div>
</div>
